"use strict";

exports.__esModule = true;
exports.ComponentRemainingLifeFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ComponentRemainingLifeFields = exports.ComponentRemainingLifeFields = function ComponentRemainingLifeFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    checked: element.props.hidePlanName || false,
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ComponentRemainingLife.hidePlanName.label",
      defaultMessage: "Hide Plan Name"
    }),
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "hidePlanName", e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    checked: element.props.hideRemainingLife || false,
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ComponentRemainingLife.hideRemainingLife.label",
      defaultMessage: "Hide Remaining Life % Metric"
    }),
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "hideRemainingLife", e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    checked: element.props.hideCumulativeUsage || false,
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ComponentRemainingLife.hideCumulativeUsage.label",
      defaultMessage: "Hide cumulative usage from task close"
    }),
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "hideCumulativeUsage", e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    checked: element.props.hideMaintenancePredictedOrDueDate || false,
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ComponentRemainingLife.hideMaintenancePredictedOrDueDate.label",
      defaultMessage: "Hide Maintenance Predicted or Due Date"
    }),
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "hideMaintenancePredictedOrDueDate", e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    checked: element.props.hideLastClosedMaintenanceDate || false,
    label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ComponentRemainingLife.hideLastClosedMaintenanceDate.label",
      defaultMessage: "Hide last closed maintenance task date"
    }),
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "hideLastClosedMaintenanceDate", e.target.checked);
    }
  }));
};